/* Kampaaniafiltri andmekiht: tooteloend + tootekaardid, sessionStorage vahemälu (10 min), paralleelne laadimine ja eellaadimine. */
(function () {
  var P = location.pathname;
  var IS_COL = /^\/collections\//.test(P), IS_SEARCH = /^\/search\/?$/.test(P);
  if (window.__kamp || !(IS_COL || IS_SEARCH)) return;
  var SALE = 'parimad-pakkumised';
  var TTL = 10 * 60 * 1000;
  var SPECS = [{ key: 'kamp', param: 'kampaania', label: 'Kampaaniatooted', tot: '__kampTot' }];
  var itemsP = null, cardCache = {}, warmed = false;

  function qs() { return new URLSearchParams(location.search); }
  function isOn(s) { return qs().get(s.param) === '1'; }
  function onList() { return SPECS.filter(isOn); }
  function flag(it) { return it.sale; }
  function handleOf(h) { var m = /\/products\/([^/?#]+)/.exec(h || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function params() {
    var p = qs();
    SPECS.forEach(function (s) { p.delete(s.param); });
    ['page', 'section_id'].forEach(function (k) { p.delete(k); });
    return p;
  }
  function colBase() {
    var seg = P.split('/');
    return '/collections/' + seg[2] + (seg[3] ? '/' + seg[3] : '');
  }
  function ctxId() { return IS_SEARCH ? 'search:' + (qs().get('q') || '') : colBase(); }
  function keyOf(name) {
    if (name === 'filter.p.vendor') return 'vendor';
    var m = /^filter\.p\.m\.custom\.(\w+)/.exec(name);
    return m ? m[1] : null;
  }

  /* ---------- sessionStorage vahemälu (säilib tootelehele minekul ja tagasi tulekul) ---------- */
  function ssGet(k) {
    try {
      var raw = sessionStorage.getItem(k);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || Date.now() - o.t > TTL) { sessionStorage.removeItem(k); return null; }
      return o.d;
    } catch (e) { return null; }
  }
  function ssSet(k, d) {
    try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }

  /* ---------- andmed ---------- */
  function pagesJson(urlFn) {
    return fetch(urlFn(1)).then(function (r) { return r.json(); }).then(function (j) {
      var out = (j.items || []).slice();
      var n = Math.min(j.pages || 1, 40), reqs = [];
      for (var i = 2; i <= n; i++) reqs.push(fetch(urlFn(i)).then(function (r) { return r.json(); }).then(function (x) { return x.items || []; }));
      return Promise.all(reqs).then(function (parts) { parts.forEach(function (a) { out = out.concat(a); }); return out; });
    });
  }
  function curSet() {
    var seg = P.split('/'), map = {};
    if (seg[3]) {
      return pagesJson(function (n) { return colBase() + '?view=kamp&page=' + n; }).then(function (list) {
        list.forEach(function (it) { map[it.h] = { price: it.p, sale: it.s ? 1 : 0 }; });
        return map;
      });
    }
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(seg[2]) + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          (j.products || []).forEach(function (p) {
            var min = Infinity;
            (p.variants || []).forEach(function (v) { min = Math.min(min, parseFloat(v.price)); });
            map[p.handle] = { price: min, sale: (p.variants || []).some(function (v) { return parseFloat(v.compare_at_price) > parseFloat(v.price); }) ? 1 : 0 };
          });
          return (j.products || []).length === 250 ? page(n + 1) : null;
        });
    }
    return page(1).then(function () { return map; });
  }
  function toMap(list) { var m = {}; list.forEach(function (it) { m[it.h] = it; }); return m; }
  function items() {
    if (itemsP) return itemsP;
    var ik = 'kampItems2:' + ctxId();
    var saved = ssGet(ik);
    if (saved) { itemsP = Promise.resolve(saved); return itemsP; }
    var p;
    if (IS_SEARCH) {
      var q = qs().get('q') || '';
      p = pagesJson(function (n) { return '/search?q=' + encodeURIComponent(q) + '&type=product&view=kamp&page=' + n; }).then(function (list) {
        var out = {};
        list.forEach(function (it) { out[it.h] = { price: it.p, v: it.v, m: it.m, sale: it.s ? 1 : 0 }; });
        return out;
      });
    } else {
      var cs = curSet();
      var sm = pagesJson(function (n) { return '/collections/' + SALE + '?view=kamp&page=' + n; }).then(toMap);
      p = Promise.all([cs, sm]).then(function (r) {
        var c = r[0], s = r[1], out = {};
        Object.keys(c).forEach(function (h) { if (c[h].sale && s[h]) out[h] = { price: c[h].price, v: s[h].v, m: s[h].m, sale: 1 }; });
        return out;
      });
    }
    itemsP = p.then(function (out) { ssSet(ik, out); return out; });
    itemsP.catch(function () { itemsP = null; });
    return itemsP;
  }

  /* ---------- kaardid (tootekaardid, mis kuvatakse filtri sisselülitamisel) ---------- */
  function fetchCardPage(urlFn, n) {
    return fetch(urlFn(n)).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var els = doc.querySelectorAll('#product-grid .grid__item');
      var more = IS_SEARCH ? els.length >= 24 : !!doc.querySelector('#load-more-btn');
      return { els: els, more: more };
    });
  }
  // laeb mitu lehte korraga (järjest ootamise asemel) ja peatub, kui kõik vajalikud kaardid on leitud
  function cardsFrom(urlFn, need) {
    var list = [], seen = {}, left = Object.keys(need).length, BATCH = 4;
    function batch(start) {
      var reqs = [];
      for (var i = 0; i < BATCH && start + i <= 40; i++) reqs.push(fetchCardPage(urlFn, start + i));
      return Promise.all(reqs).then(function (res) {
        var more = true;
        res.forEach(function (p) {
          if (!more) return;
          p.els.forEach(function (it) {
            var a = it.querySelector('a[href*="/products/"]');
            if (!a) return;
            var h = handleOf(a.getAttribute('href'));
            if (seen[h]) return;
            seen[h] = 1;
            list.push({ h: h, el: it });
            if (need[h]) left--;
          });
          more = p.more;
        });
        return more && left > 0 && start + BATCH <= 40 ? batch(start + BATCH) : list;
      });
    }
    return batch(1);
  }
  function covers(list, need) {
    var have = {};
    list.forEach(function (c) { have[c.h] = 1; });
    return Object.keys(need).every(function (h) { return have[h]; });
  }
  function inflate(x) {
    var t = document.createElement('template');
    t.innerHTML = x.html;
    return { h: x.h, el: t.content.firstElementChild };
  }
  function cards(sid, need) {
    var sort = params().get('sort_by') || '';
    var q = new URLSearchParams(); if (sort) q.set('sort_by', sort);
    var ck = (IS_SEARCH ? 'search' : 'kamp') + '|' + ctxId() + '|' + sort;
    var sk = 'kampCards2:' + ck;
    var urlFn = function (n) {
      var u = new URLSearchParams(q.toString()); u.set('section_id', sid); u.set('page', n);
      if (!IS_SEARCH) return '/collections/' + SALE + '?' + u.toString();
      u.set('q', qs().get('q') || ''); if (qs().get('type')) u.set('type', qs().get('type'));
      return '/search?' + u.toString();
    };
    function fresh() {
      var p = cardsFrom(urlFn, need).then(function (list) {
        ssSet(sk, list.map(function (c) { return { h: c.h, html: c.el.outerHTML }; }));
        return list;
      });
      cardCache[ck] = p;
      p.catch(function () { if (cardCache[ck] === p) delete cardCache[ck]; });
      return p;
    }
    if (cardCache[ck]) return cardCache[ck].then(function (l) { return covers(l, need) ? l : fresh(); });
    var saved = ssGet(sk);
    if (saved) {
      var l = saved.map(inflate);
      if (covers(l, need)) { cardCache[ck] = Promise.resolve(l); return cardCache[ck]; }
    }
    return fresh();
  }
  // eellaeb kaardid enne, kui kasutaja filtri sisse lülitab
  function warm() {
    if (warmed) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    warmed = true;
    items().then(function (all) {
      var set = {};
      Object.keys(all).forEach(function (h) { if (all[h].sale) set[h] = 1; });
      if (!Object.keys(set).length) return;
      return cards(grid.dataset.id, set);
    }).catch(function () { warmed = false; });
  }

  /* ---------- valitud filtrid ---------- */
  function selected() {
    var g = {}, p = params();
    p.forEach(function (v, k) { var key = keyOf(k); if (key) (g[key] = g[key] || []).push(v); });
    return { g: g, gte: parseFloat(p.get('filter.v.price.gte')), lte: parseFloat(p.get('filter.v.price.lte')) };
  }
  function attr(it, key) { return key === 'vendor' ? [it.v] : (it.m && it.m[key]) || []; }
  function pass(it, sel, skip) {
    var pr = it.price;
    if (!isNaN(sel.gte) && pr < sel.gte) return false;
    if (!isNaN(sel.lte) && pr > sel.lte) return false;
    return Object.keys(sel.g).every(function (k) {
      if (k === skip) return true;
      var a = attr(it, k);
      return sel.g[k].some(function (v) { return a.indexOf(v) > -1; });
    });
  }
  function bump(text, n) {
    return text.replace(/\((\d+)\)/, '(' + n + ')').replace(/\d+(\s+(?:toode|tulemust))/, n + '$1');
  }

  window.__kamp = {
    P: P, IS_SEARCH: IS_SEARCH, SPECS: SPECS, qs: qs, isOn: isOn, onList: onList, flag: flag, params: params,
    colBase: colBase, ctxId: ctxId, keyOf: keyOf, items: items, cards: cards, warm: warm,
    isWarmed: function () { return warmed; }, selected: selected, attr: attr, pass: pass, bump: bump
  };
})();